import type {
  AutoSuggestComplianceEntry,
  AutoSuggestComplianceFormatterParams,
  AutoSuggestDisplayText,
} from './createAutoSuggestComplianceFormatter.types';

/**
 * Creates a formatter that applies an AEM-configured display replacement to
 * the first exact auto-suggestion match.
 */
export const createAutoSuggestComplianceFormatter = (
  autoSuggestComplianceList: AutoSuggestComplianceEntry[] | undefined
): ((params: AutoSuggestComplianceFormatterParams) => AutoSuggestDisplayText) => {
  return ({
    suggestion,
    index,
    inputValue,
  }: AutoSuggestComplianceFormatterParams): AutoSuggestDisplayText => {
    const originalDisplayText = {
      primaryDescription: suggestion?.primaryDescription,
      secondaryDescription: suggestion?.secondaryDescription ?? '',
    };

    if (index !== 0 || !inputValue || !Array.isArray(autoSuggestComplianceList)) {
      return originalDisplayText;
    }

    const autoSuggestDisplayText = [suggestion?.primaryDescription, suggestion?.secondaryDescription]
      .filter(Boolean)
      .join(' ');
    const matchingEntry = autoSuggestComplianceList.find(
      entry =>
        entry?.input === inputValue &&
        entry?.autoSuggest === autoSuggestDisplayText &&
        typeof entry?.textToReplace === 'string' &&
        entry.textToReplace.trim().length > 0
    );
    const replacementText = matchingEntry?.textToReplace?.trim();

    if (!replacementText) {
      return originalDisplayText;
    }

    const separatorIndex = replacementText.search(/\s/);

    if (separatorIndex === -1) {
      return {
        primaryDescription: replacementText,
        secondaryDescription: '',
      };
    }

    return {
      primaryDescription: replacementText.slice(0, separatorIndex),
      secondaryDescription: replacementText.slice(separatorIndex).trim(),
    };
  };
};
